import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DuoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"duo"}/>
}
